import { RawSkillAssessmentDto } from '@/api/generated';
import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';
import { useApiClient } from '@/api/util/useApiClient.util';
import { useUserContext } from '@/utils/providers/userContext/useUserContext.tsx';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';

type Req = RawSkillAssessmentDto[];

interface Return {
  assessUserSkills: (req: Req) => Promise<void>;
  error: AxiosError | null;
  isLoading: boolean;
}

export const useAssessUserSkills = (): Return => {
  const { restSkillsApi } = useApiClient();
  const { user } = useUserContext();
  const queryClient = useQueryClient();

  const { error, isPending, mutateAsync } = useMutation<void, AxiosError, Req>({
    mutationFn: async req => {
      if (user?.userId) {
        await restSkillsApi.assessUserSkills(user.userId, req);
      }
    },
    mutationKey: [QueryKeyEnum.ASSESS_USER_SKILLS],
    onSuccess: async () => {
      await queryClient.refetchQueries({
        queryKey: [QueryKeyEnum.PROCESS, user?.userId],
      });
    },
  });

  return { assessUserSkills: mutateAsync, error, isLoading: isPending };
};
